module.exports = __webpack_public_path__ + "img/irigo-atout.1c2a8efd.jpg";